__turbopack_context__.v({
  "card": "QleHba_card",
});
